// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Fq-z","imageAndVideoCount":"Gq-z","imageAndVideoContainer":"Hq-z","viewAllReviews":"Iq-z"};